export const descargar = (blob, nombre) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = nombre;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

// Un error de la exportación llega como blob JSON: se extrae el mensaje.
export const mensajeError = async (err) => {
  try {
    const texto = await err.response.data.text();
    return JSON.parse(texto).error;
  } catch (_e) {
    return 'No se pudo exportar a Excel.';
  }
};
